import * as t from 'io-ts'
import { DateFromISOString } from 'io-ts-types'

export const HistoryItemC = t.type({
  createdBy: t.string,
  createdDate: DateFromISOString,
  version: t.number
})
export type HistoryItem = t.TypeOf<typeof HistoryItemC>
